import { liquidSettleEvent } from '@/play/liquid/changes'
import { liquidKind } from '@/play/liquid/kind'

/** Sludge is glossy blob voxels (gooey SDF surfaces that merge): every blob in a Sludge world is sludge. */
export const SLUDGE_LIQUID = liquidKind('blob')

/**
 * One input's goo and its slump, one event per pointer event; a whole stroke is one undo step. The
 * coalescer accumulates in place, so committing a long stroke costs O(cells), not O(events x cells).
 */
export const SLUDGE_SETTLE = liquidSettleEvent('experience.sludge.settle', SLUDGE_LIQUID)

/** Reducer handlers for Sludge (`experience.sludge.*`). */
export const eventHandlers = SLUDGE_SETTLE.handlers
